import { render, staticRenderFns } from "./AddFaqModal.vue?vue&type=template&id=1a70c6d3&"
import script from "./AddFaqModal.vue?vue&type=script&lang=js&"
export * from "./AddFaqModal.vue?vue&type=script&lang=js&"
import style0 from "./AddFaqModal.vue?vue&type=style&index=0&id=1a70c6d3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports